<template>
  <div class="ai-upgrade-nudge">
    <img class="nudge-illustration" :src="illustration" alt="" />
    <div class="nudge-body">
      <h3 class="nudge-title">{{ title }}</h3>
      <p class="nudge-desc">{{ description }}</p>
      <vs-button class="nudge-cta" @click="goPremium">{{ ctaLabel }}</vs-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UpgradeNudge',
  props: {
    title: { type: String, default: 'Limite gratuito raggiunto' },
    description: { type: String, default: 'Hai raggiunto il limite gratuito per l’Assistente AI. Passa a Premium per continuare a usare questa funzione senza limiti.' },
    ctaLabel: { type: String, default: 'Scopri Premium' },
    illustration: { type: String, default: '/email/welcome.png' }
  },
  methods: {
    goPremium() {
      try { this.$router.push({ name: 'Sottoscrizione' }); } catch (e) {console.debug('Navigation to Sottoscrizione failed');}
    }
  }
};
</script>

<style scoped>
.ai-upgrade-nudge {
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
  background: rgba(255, 255, 255, 0.8);
  border: 1px solid rgba(39,48,63,0.10);
  border-radius: 16px;
  padding: 16px;
  max-width: 85%;
  width: 100%;
  box-shadow: 0 6px 18px rgba(16,24,40,0.08);
}
.nudge-illustration {
  width: 140px;
  height: auto;
  border-radius: 12px;
  object-fit: cover;
  flex-shrink: 0;
  margin: 0 auto;
}
.nudge-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  width: 100%;
  text-align: center;
}
.nudge-title {
  font-size: 15px;
  font-weight: 800;
  margin: 0;
  color: #27303f;
}
.nudge-desc {
  font-size: 13px;
  color: rgba(39,48,63,0.75);
  margin: 0;
}
.nudge-cta {
  align-self: stretch;
  margin-top: 8px !important;
  height: 40px !important;
  font-size: 14px !important;
  padding: 8px 12px !important;
  width: 100% !important;
}
</style>
